<template>
  <complex-select
    :tb-head="Head"
    :tb-data="Data"
    :key-str="keyword"
    v-model="value1"
    @select="onSelect"
  />
</template>
<script>
import complexSelect from "@/components/common/complexSelect";
export default {
  components: {
    complexSelect,
  },
  props: {
    init: {
      type: Boolean,
      default: false,
    },
    source: {
      type: Array,
      default: () => [],
    },
    keyword: {
      type: String,
      default: "ItemName",
    },
    value: {},
  },
  data() {
    return {
      api: require("@/api/ba/item").default,
      Head: [
        { Value: "ItemCode", Name: "项目编号", Width: "160", },
        { Value: "ItemName", Name: "项目名称", Width: "180" },
        // { Value: "ItemType", Name: "费用类型", Width: "150" },
      ],
      Data: [],
      value1: "",
    };
  },
  watch: {
    value() {
      // console.log("watch", this.value);
      this.value1 = this.value;
    },
    source() {
      this.Data = this.source;
    },
  },
  mounted() {
    this.value1 = this.value;
    if (this.init) this.initData();
    else this.Data = this.source;
  },
  methods: {
    initData() {
      console.log("初始化");
      this.api.list({ Status: 1, ItemType: 0 }).then((res) => {
        console.log('res', res)
        if (res.Code == 0) this.Data = res.Data;
      });
    },
    onSelect(data) {
      console.log("select", data);
      this.$emit("input", data[this.keyword]);
      this.$emit("select", data);
    },
  },
};
</script>